import { OuiValidationError } from 'omnium-ui/form-field';

export function tvaIntracommunautaireValidatorErrors(): OuiValidationError[] {
  return [
    {
      code: 'tvaIntra',
      message: 'Format attendu: FR12 345678901 ou FR12345678901',
    },
  ];
}
